export enum SuspenUserName {
	suspensionReason = 'suspensionReason',
}
